var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAuths(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 115630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 115439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 115438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_1_4247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 11003",
    d: "M72.999 9.99902H35.999C22.1919 9.99902 10.999 21.1919 10.999 34.999V71.999C10.999 85.8061 22.1919 96.999 35.999 96.999H72.999C86.8061 96.999 97.999 85.8061 97.999 71.999V34.999C97.999 21.1919 86.8061 9.99902 72.999 9.99902Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 115412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 109829",
    d: "M79.2993 42.949C78.5 39.7107 76.6761 36.8171 74.0993 34.699C71.6808 32.6909 68.6447 31.5764 65.5013 31.543C63.161 31.5442 60.8666 32.1921 58.8713 33.415C57.1773 34.4562 55.6942 35.8067 54.4993 37.396C51.5853 33.604 47.7433 31.543 43.4943 31.543C40.3519 31.5766 37.3168 32.6911 34.8993 34.699C32.3227 36.8173 30.4989 39.7108 29.6993 42.949C28.7813 46.549 28.5993 52.297 32.9693 59.258C37.0093 65.701 44.0123 71.67 53.7843 77C54.0023 77.1189 54.2465 77.1812 54.4948 77.1812C54.7431 77.1812 54.9874 77.1189 55.2053 77C64.9793 71.669 71.9853 65.7 76.0263 59.258C80.3923 52.297 80.2163 46.548 79.2983 42.95L79.2993 42.949Z",
    fill: "#FF5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 109830",
    d: "M79.3 42.949C78.5006 39.7107 76.6768 36.8171 74.1 34.699C71.6809 32.6904 68.6441 31.576 65.5 31.543C63.1587 31.5437 60.8632 32.1916 58.867 33.415C57.1751 34.4551 55.6937 35.8038 54.5 37.391V77.181C54.7467 77.1803 54.9894 77.1181 55.206 77C64.981 71.669 71.986 65.7 76.027 59.258C80.394 52.297 80.217 46.547 79.3 42.949Z",
    fill: "#FF0059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 109831",
    d: "M39.9324 55.026L41.7844 51.326L46.8144 61.387C46.9378 61.6334 47.1272 61.8405 47.3616 61.9853C47.5959 62.13 47.866 62.2067 48.1414 62.2067C48.4169 62.2067 48.6869 62.13 48.9213 61.9853C49.1557 61.8405 49.3451 61.6334 49.4684 61.387L54.4994 51.326L56.3514 55.026C56.4747 55.2724 56.6641 55.4796 56.8985 55.6245C57.1329 55.7693 57.4029 55.846 57.6784 55.846H68.9324C69.326 55.846 69.7035 55.6897 69.9818 55.4114C70.2601 55.1331 70.4164 54.7556 70.4164 54.362C70.4164 53.9684 70.2601 53.591 69.9818 53.3127C69.7035 53.0344 69.326 52.878 68.9324 52.878H58.5954L55.8234 47.341C55.7001 47.0947 55.5107 46.8876 55.2763 46.7428C55.0419 46.598 54.7719 46.5214 54.4964 46.5214C54.221 46.5214 53.9509 46.598 53.7166 46.7428C53.4822 46.8876 53.2928 47.0947 53.1694 47.341L48.1394 57.402L43.1084 47.341C42.9852 47.0944 42.7958 46.887 42.5613 46.7421C42.3268 46.5971 42.0566 46.5204 41.7809 46.5204C41.5053 46.5204 41.2351 46.5971 41.0006 46.7421C40.7661 46.887 40.5767 47.0944 40.4534 47.341L37.6854 52.879H30.0234C30.3275 53.8917 30.699 54.8829 31.1354 55.846H38.6074C38.883 55.8461 39.1531 55.7694 39.3875 55.6246C39.6219 55.4798 39.8113 55.2725 39.9344 55.026H39.9324Z",
    fill: "#E7F0EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 109832",
    d: "M68.932 52.878H58.595L55.827 47.34C55.7038 47.0938 55.5145 46.8867 55.2803 46.7419C55.0462 46.5971 54.7763 46.5203 54.501 46.52V51.32L56.352 55.02C56.4753 55.2666 56.6649 55.4739 56.8995 55.6187C57.134 55.7635 57.4043 55.8402 57.68 55.84H68.934C69.3275 55.84 69.705 55.6837 69.9833 55.4054C70.2616 55.1271 70.418 54.7496 70.418 54.356C70.418 53.9625 70.2616 53.585 69.9833 53.3067C69.705 53.0284 69.3275 52.872 68.934 52.872L68.932 52.878Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4247",
    x: -0.000976562,
    y: -0.000976562,
    width: 109,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.607843 0 0 0 0 0.607843 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4247",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAuths);
export default __webpack_public_path__ + "static/media/logo-auths.0e3c0d2ade7dd5729240a67f1ce37c18.svg";
export { ForwardRef as ReactComponent };